export const BUTTON_SIZE = 80
export const STROKE_WIDTH = 4
